module.exports = __webpack_public_path__ + "static/media/userAdd.77bf8c4a.svg";